import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { setCarousel } from "../actions/settingActions";

import FadeLoader from "react-spinners/FadeLoader";

import { withStyles } from "@material-ui/core/styles";
import withWidth, { isWidthUp } from "@material-ui/core/withWidth";
import Backdrop from "@material-ui/core/Backdrop";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import MobileStepper from "@material-ui/core/MobileStepper";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";

import { copyright } from "../data/copyright";

import { ReactComponent as Close } from "../icons/close.svg";

const styles = (theme) => ({
  content: {
    padding: "8px",
  },
  progress: {
    width: "100%",
  },
});

const DialogTitle = (props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          style={{ position: "absolute", right: "8px", top: "5px" }}
          onClick={onClose}
        >
          <Close />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
};

class ImageDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      pictures: props.images,
      index: props.i,
      progress: true,
    };
  }

  componentDidMount() {
    window.addEventListener("keydown", this.keyNavigation);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.open !== this.props.open && this.props.open) {
      this.props.setCarousel("details");
      this.setState({ open: true });
    }
    if (prevProps.i !== this.props.i) {
      this.setState({ index: this.props.i, progress: true });
    }
  }

  componentWillUnmount() {
    window.removeEventListener("keydown", this.keyNavigation);
  }

  keyNavigation = (event) => {
    if (this.state.open && this.state.pictures.length > 1) {
      if (event.key === "ArrowLeft" || event.keyCode === 37) {
        this.back();
      }
      if (event.key === "ArrowRight" || event.keyCode === 39) {
        this.next();
      }
    }
  };

  toggle = () => {
    this.setState({ open: !this.state.open });
  };

  back = () => {
    if (this.state.index < 1) {
      this.setState({ index: this.state.pictures.length - 1, progress: true });
    } else {
      this.setState({ index: this.state.index - 1, progress: true });
    }
  };

  next = () => {
    var newIndex = (this.state.index + 1) % this.state.pictures.length;
    this.setState({ index: newIndex, progress: true });
  };

  render() {
    const isEdge = window.navigator.userAgent.indexOf("Edge") !== -1;
    const isIE =
      window.navigator.userAgent.indexOf("Trident") !== -1 && !isEdge;
    return (
      <Backdrop
        open={this.state.open}
        onClose={() => {
          this.toggle();
          this.props.setCarousel("images");
        }}
        style={{ zIndex: 1303 }}
      >
        <Dialog
          open={this.state.open}
          onClose={() => {
            this.toggle();
            this.props.setCarousel("images");
          }}
          style={{ zIndex: 1304 }}
          maxWidth={"lg"}
        >
          <DialogTitle
            style={{ backgroundColor: "#00568E", color: "white" }}
            onClose={() => {
              this.toggle();
              this.props.setCarousel("images");
            }}
            classes={this.props.classes}
          >
            {this.props.millName}
          </DialogTitle>
          <DialogContent classes={{ root: this.props.classes.content }}>
            {isWidthUp("sm", this.props.width) ? (
              <div style={{ width: "100%", height: "100%" }}>
                <MobileStepper
                  style={{
                    width: "100%",
                    height: "4px",
                    justifyContent: "center",
                    display: "flex",
                    alignItems: "center",
                    padding: 0,
                    marginTop: "-12px",
                    marginLeft: "-8px",
                    position: "absolute",
                    zIndex: 999,
                  }}
                  classes={{ progress: this.props.classes.progress }}
                  variant="progress"
                  steps={this.state.pictures.length + 1}
                  position="static"
                  activeStep={this.state.index + 1}
                />
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    justifyContent: "center",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {this.state.pictures.length > 1 ? (
                    <IconButton
                      onClick={this.back}
                      className={"carousel-button"}
                      style={{
                        backgroundColor: "#00568E",
                        fill: "white",
                        width: "43px",
                        height: "43px",
                        padding: 0,
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="30px"
                        viewBox="0 0 24 24"
                        width="30px"
                        fill="inherit"
                      >
                        <path d="M0 0h24v24H0z" fill="none" />
                        <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
                      </svg>
                    </IconButton>
                  ) : null}
                  {this.state.progress ? (
                    <div
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "calc(50% - 25px)",
                      }}
                    >
                      <FadeLoader
                        color={"#00568E"}
                        loading={this.state.progress}
                        size={35}
                        margin={5}
                      />
                    </div>
                  ) : null}
                  <div
                    style={{
                      display: "flex",
                      width: "calc(100%)",
                      maxHeight: "calc(100vh - 8px - 64px - 80px)",
                      justifyContent: "center",
                      position: "relative",
                    }}
                  >
                    <img
                      src={`${this.state.pictures[this.state.index]}`}
                      alt=""
                      style={
                        isIE
                          ? {
                              width: "100%",
                              // maxWidth: "calc(100% - 20px - 20px)",
                              visibility: this.state.progress
                                ? "hidden"
                                : "visible",
                            }
                          : {
                              maxWidth: "calc(100% - 20px - 20px)",
                              visibility: this.state.progress
                                ? "hidden"
                                : "visible",
                              objectFit: "contain",
                            }
                      }
                      onLoad={() => this.setState({ progress: false })}
                    />
                    {copyright.includes(
                      this.state.pictures[this.state.index]
                    ) ? (
                      <div
                        style={{
                          backgroundColor: "rgba(255,255,255,0.7)",
                          position: "absolute",
                          bottom: 0,
                          right: 0,
                          padding: "0 5px",
                          fontSize: "9pt",
                          textAlign: "right",
                        }}
                      >
                        Foto: Angelika Brockmann-Peschel, © LWL-DLBW
                      </div>
                    ) : null}
                  </div>
                  {this.state.pictures.length > 1 ? (
                    <IconButton
                      onClick={this.next}
                      className={"carousel-button"}
                      style={{
                        backgroundColor: "#00568E",
                        fill: "white",
                        width: "43px",
                        height: "43px",
                        padding: 0,
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="30px"
                        viewBox="0 0 24 24"
                        width="30px"
                        fill="inherit"
                      >
                        <path d="M0 0h24v24H0z" fill="none" />
                        <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
                      </svg>
                    </IconButton>
                  ) : null}
                </div>
              </div>
            ) : (
              <div style={{ width: "100%", height: "100%" }}>
                <div
                  style={{
                    height:
                      this.state.pictures.length > 1
                        ? "calc(100% - 43px - 15px)"
                        : "100%",
                    justifyContent: "center",
                    display: "flex",
                  }}
                >
                  {this.state.progress ? (
                    <div
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "calc(50% - 25px)",
                      }}
                    >
                      <FadeLoader
                        color={"#00568E"}
                        loading={this.state.progress}
                        size={35}
                        margin={5}
                      />
                    </div>
                  ) : null}
                  <div
                    style={{
                      display: "flex",
                      width: "calc(100%)",
                      height: "calc(100% - 8px)",
                      justifyContent: "center",
                      position: "relative",
                    }}
                  >
                    <img
                      src={`${this.state.pictures[this.state.index]}`}
                      alt=""
                      style={
                        isIE
                          ? {
                              width: "100%",
                              // maxWidth: "calc(100% - 20px - 20px)",
                              visibility: this.state.progress
                                ? "hidden"
                                : "visible",
                            }
                          : {
                              maxWidth: "calc(100% - 20px - 20px)",
                              visibility: this.state.progress
                                ? "hidden"
                                : "visible",
                            }
                      }
                      onLoad={() => this.setState({ progress: false })}
                    />
                    {copyright.includes(
                      this.state.pictures[this.state.index]
                    ) ? (
                      <div
                        style={{
                          backgroundColor: "rgba(255,255,255,0.7)",
                          position: "absolute",
                          bottom: 0,
                          right: 0,
                          padding: "0 5px",
                          fontSize: "9pt",
                          textAlign: "right",
                        }}
                      >
                        Foto: Angelika Brockmann-Peschel, © LWL-DLBW
                      </div>
                    ) : null}
                  </div>
                </div>
                {this.state.pictures.length > 1 ? (
                  <div>
                    <MobileStepper
                      style={{
                        width: "100%",
                        height: "43px",
                        justifyContent: "center",
                        display: "flex",
                        alignItems: "center",
                        padding: 0,
                        margin: "10px 0px 10px 0px",
                        // marginTop: "10px",
                      }}
                      variant="progress"
                      steps={this.state.pictures.length + 1}
                      position="static"
                      activeStep={this.state.index + 1}
                      backButton={
                        <IconButton
                          onClick={this.back}
                          className={"carousel-button"}
                          style={{
                            backgroundColor: "#00568E",
                            fill: "white",
                            width: "43px",
                            height: "43px",
                            padding: 0,
                            marginRight: "20px",
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            height="30px"
                            viewBox="0 0 24 24"
                            width="30px"
                            fill="inherit"
                          >
                            <path d="M0 0h24v24H0z" fill="none" />
                            <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
                          </svg>
                        </IconButton>
                      }
                      nextButton={
                        <IconButton
                          onClick={this.next}
                          className={"carousel-button"}
                          style={{
                            backgroundColor: "#00568E",
                            fill: "white",
                            width: "43px",
                            height: "43px",
                            padding: 0,
                            marginLeft: "20px",
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            height="30px"
                            viewBox="0 0 24 24"
                            width="30px"
                            fill="inherit"
                          >
                            <path d="M0 0h24v24H0z" fill="none" />
                            <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
                          </svg>
                        </IconButton>
                      }
                    />
                  </div>
                ) : null}
              </div>
            )}
          </DialogContent>
        </Dialog>
      </Backdrop>
    );
  }
}

ImageDetails.propTypes = {
  millName: PropTypes.string.isRequired,
  pictures: PropTypes.array.isRequired,
  setCarousel: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  millName: state.mill.selected.Name,
  pictures: state.mill.selected.Bilder,
});

export default connect(mapStateToProps, { setCarousel })(
  withWidth()(withStyles(styles, { withTheme: true })(ImageDetails))
);
